import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function FeeReminderCard({ canSend }) {
  const [s, setS] = useState({});
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/fee-mgmt/reminders/status").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  async function send() {
    setBusy(true);
    try { await api.post("/fee-mgmt/reminders/send-now"); toast.success("Checking installments and sending reminders"); setTimeout(load, 4000); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  }

  return (
    <div data-testid="fee-reminder-card" className="bg-white rounded-2xl p-4 shadow-sm flex flex-wrap items-center gap-3">
      <div className="h-11 w-11 rounded-xl flex items-center justify-center bg-violet-50 text-violet-700"><BellRing size={20} /></div>
      <div className="flex-1 min-w-[200px]">
        <div className="font-semibold text-slate-900">Automatic fee reminders</div>
        <div className="text-xs text-slate-500">Every day at 9am IST parents get an email 3 days before an installment is due, and once when it becomes overdue.</div>
        <div data-testid="fee-reminder-status" className="text-xs text-slate-500 mt-1">
          {s.status === "done" ? `Last run: ${s.sent} sent, ${s.failed} failed` : s.status ? `Last run: ${s.status}` : "No run yet"} • {s.total_sent || 0} reminders sent in total
          <br />WhatsApp: {s.whatsapp_ready ? `on • ${s.whatsapp_sent || 0} sent to the parent phone on each student record` : "not connected yet (Twilio keys needed)"}
        </div>
      </div>
      {canSend && (
        <Button data-testid="fee-reminder-send-now" variant="outline" onClick={send} disabled={busy}>
          {busy ? <Loader2 size={15} className="animate-spin mr-1" /> : <BellRing size={15} className="mr-1" />} Send due reminders now
        </Button>
      )}
    </div>
  );
}
